var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookWhiteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.808 25v-8.915H10v-3.21h2.808v-2.742c0-2.154 1.659-4.133 5.48-4.133 1.548 0 2.693.125 2.693.125l-.09 2.997s-1.168-.01-2.441-.01c-1.378 0-1.6.534-1.6 1.419v2.344H21l-.18 3.21h-3.97V25h-4.042z",
    fill: "#fff"
  })));
}

export default SvgFacebookWhiteIcon;